export const getPlaceInfoFromTicket = (ticket: wix.events.ticketing.Ticket) => ({
  area: ticket?.ticketDetails?.areaName,
  table: ticket?.ticketDetails?.tableName,
})
